var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "750" },
      on: {
        "click:outside": function($event) {
          return _vm.closeDialog()
        }
      }
    },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-container",
            { staticClass: "shipperCon" },
            [
              _c(
                "v-card-title",
                { staticClass: "my-0 py-0 pt-0 heading-6" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "my-2",
                      attrs: { justify: "space-between" }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pb-4",
                          attrs: { align: "start" }
                        },
                        [
                          _c("div", { staticClass: "text-no-wrap" }, [
                            _vm._v(
                              "\n              Select Export Details\n            "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 ma-0 pr-4",
                          attrs: { align: "end" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { dense: "" } }, [
                                _vm._v("mdi-close")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                _vm._l(_vm.detailSelectionList, function(detail, index) {
                  return _c(
                    "v-col",
                    { key: index, attrs: { cols: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { value: detail, label: detail.label },
                        model: {
                          value: _vm.details,
                          callback: function($$v) {
                            _vm.details = $$v
                          },
                          expression: "details"
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-row",
                { staticClass: "mb-2 mr-2", attrs: { justify: "end" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: _vm.details.length === 0
                      },
                      on: { click: _vm.exportItems }
                    },
                    [
                      _vm._v("\n          Export\n          "),
                      _c(
                        "v-icon",
                        { staticClass: "pl-2 pt-0", attrs: { size: "large" } },
                        [_vm._v("\n            mdi-download\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9ca33e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ca33e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportDetailsModal.vue
// module id = null
// module chunks = 